import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { EmptyComponent } from './EmptyComponent';
export const AsyncFileManager = Loadable({
  loader: () => import( /* webpackChunkName: "file-manager" */'./FileManager'),
  LoadingComponent: EmptyComponent
});